import { Box } from '@mui/material';
import styles from './generalDataSkeleton.module.scss';

const GeneralDataSkeleton = () => {
  return (
    <Box
      className={styles.wrapper}
      data-testid='general-data-skeleton'
      aria-busy='true'
      aria-label='Loading general project data'
    >
      <section className={styles.section} aria-label='Loading project summary'>
        <div className={styles.startGrid}>
          {Array.from({ length: 8 }, (_, index) => (
            <div
              className={`${styles.card} ${index < 2 ? styles.wideCard : ''}`}
              data-testid='general-data-start-card-skeleton'
              key={`start-card-${index}`}
            >
              <span className={styles.icon} />
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
      </section>

      <section className={styles.section} aria-label='Loading organization'>
        <span className={styles.sectionTitle} />
        <div className={styles.organizationGrid}>
          {Array.from({ length: 3 }, (_, index) => (
            <div
              className={styles.card}
              data-testid='general-data-organization-card-skeleton'
              key={`organization-card-${index}`}
            >
              <span className={styles.icon} />
              <span className={styles.label} />
              <span className={styles.value} />
              <span className={styles.subValue} />
            </div>
          ))}
        </div>
      </section>

      <section className={styles.section} aria-label='Loading work types'>
        <span className={styles.sectionTitle} />
        <div className={styles.workTypes}>
          {Array.from({ length: 3 }, (_, index) => (
            <div
              className={styles.workType}
              data-testid='general-data-work-type-skeleton'
              key={`work-type-${index}`}
            >
              <span className={styles.workTypeCode} />
              <span className={styles.workTypeName} />
            </div>
          ))}
        </div>
      </section>
    </Box>
  );
};

export default GeneralDataSkeleton;
